import { render, staticRenderFns } from "./ai-chat-app.vue?vue&type=template&id=4bda39c1&scoped=true"
import script from "./ai-chat-app.vue?vue&type=script&lang=ts"
export * from "./ai-chat-app.vue?vue&type=script&lang=ts"
import style0 from "./ai-chat-app.vue?vue&type=style&index=0&id=4bda39c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bda39c1",
  null
  
)

export default component.exports